<template>
  <div class="table-box card-base box grow" id="table-wrapper">
    <el-pagination
      :small="pagination.small"
      :current-page.sync="pagination.page"
      :page-sizes="pagination.sizes"
      :page-size.sync="pagination.size"
      :layout="pagination.layout"
      :total="total"
      :hide-on-single-page="true"
    ></el-pagination>
    <el-table :data="listInPage" style="width:100%" ref="summary" :cell-style="{padding:'4px'}" stripe header-row-class-name="fs-12" empty-text="Aucune facture">
      <el-table-column label="Client">
        <template slot-scope="scope" label="Client">
          <PortausLink :id="scope.row.id" :label="customerName(scope.row.name,scope.row.usual_name)" path="/customers/" :underline="true"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column :label="$t('reports.INVOICES_DETAIL.total_draft')" align="right">
        <template slot-scope="scope" >
          <span v-for="(value, index) in formatByCurrencies('totalDraft', scope.row.totalByCurrencies)"><br v-if="index > 0"/>{{value}} </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('reports.INVOICES_DETAIL.total_voided')" align="right">
        <template slot-scope="scope" >
          <span v-for="(value, index) in formatByCurrencies('totalVoid', scope.row.totalByCurrencies)"><br v-if="index > 0"/>{{value}} </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('reports.INVOICES_DETAIL.total_invoiced')" align="right">
        <template slot-scope="scope" >
          <span v-for="(value, index) in formatByCurrencies('totalInvoiced', scope.row.totalByCurrencies)"><br v-if="index > 0"/>{{value}} </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('reports.INVOICES_DETAIL.total_paid')" align="right">
        <template slot-scope="scope" >
          <span v-for="(value, index) in formatByCurrencies('totalPaid', scope.row.totalByCurrencies)"><br v-if="index > 0"/>{{value}} </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('reports.INVOICES_DETAIL.total_credited')" align="right">
        <template slot-scope="scope">
          <span v-for="(value, index) in formatByCurrencies('totalCredited', scope.row.totalByCurrencies)"><br v-if="index > 0"/>{{value}} </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('reports.INVOICES_DETAIL.total_taxes')" align="right">
        <template slot-scope="scope">
          <span v-for="(value, index) in formatByCurrencies('totalTaxes', scope.row.totalByCurrencies)"><br v-if="index > 0"/>{{value}} </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('reports.INVOICES_DETAIL.total_outstanding')" align="right">
        <template slot-scope="scope">
          <span v-for="(value, index) in formatByCurrencies('totalOutstanding', scope.row.totalByCurrencies)"><br v-if="index > 0"/>{{value}} </span>
        </template>
      </el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <InvoicesSummary :invoices="props.row.invoices" :showCustomer="false" :showDetail="false"></InvoicesSummary>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :small="pagination.small"
      :current-page.sync="pagination.page"
      :page-sizes="pagination.sizes"
      :page-size.sync="pagination.size"
      :layout="pagination.layout"
      :total="total"
      :hide-on-single-page="true"
    ></el-pagination>
  </div>
</template>
<script>

import moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex';
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
import InvoicesSummary from '@/components/invoice/invoices-summary.vue'
import portausUtils from '@/utils/portaus-utils';
export default {
  name : "invoiceDetailCustomerView",
  props: {
    customers : Array,
    filters : Object,

	},
  data() {
    return {
      pagination: {
        page: 1,
        size: 20,
        sizes: [10, 15, 20, 30, 50, 100],
        layout: 'total, ->, prev, pager, next, sizes',
        small: false
      },
    };
  },
  components : {
    PortausLink,
    InvoicesSummary
  },
  methods : {
    formatByCurrencies(field, totalByCurrencies){
      return _.map(totalByCurrencies, (value, key) => (this.formatAmount(value[field], key)));
    },
    formatAmount(amount, currency = 'CAD') {
      // console.log('amount :',amount);
          return portausUtils.formatAmount(amount, this.$i18n.locale, currency);
		},
    customerName(name, usual_name){
      return CustomerUtil.customerName(name, usual_name);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    }
  },
  computed : {
    total() {
			return this.customers.length
		},
    listInPage(){
      let from = (this.currentPage - 1) * this.itemPerPage
      let to = from + (this.itemPerPage*1)
      //return this.listSortered.slice(from, to)
      return this.customers.slice(from, to)
    },
    currentPage: {
			get() {
				return this.pagination.page
			},
			set(val) {
				this.pagination.page = val
			}
		},
		itemPerPage() {
			return this.pagination.size
		},
    ...mapGetters('invoices',['getInvoiceTagType'])
  }
}
</script>
<style lang="scss" scoped>


</style>
